export default __webpack_public_path__ + "static/media/Montserrat-Regular.42a33ebd.woff";